import { Box, Divider, Flex, Heading, Text } from "@chakra-ui/react";
import { PropsWithChildren, ReactElement, useContext } from "react";
import { FormattedMessage } from "react-intl";
import VueContext from "../vueContext";
import { ContactPersonBasic } from "./contact-person-basic";
import { Greeting } from "./greeting";

function HeroImage({ children }: PropsWithChildren): ReactElement {
  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      px={{ base: "xl", lg: "4xl" }}
      minHeight="380px"
      width="100%"
      background="#4b4b4b"
      backgroundImage="url(/img/frontpage/header.jpg)"
      backgroundPosition="top center"
      backgroundSize="cover"
      borderRadius="base"
      position="relative"
      overflow="hidden"
      mr={{ lg: "4xl" }}
      sx={{
        "&::before": {
          content: "''",
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.4)",
        },
      }}
      maxWidth="100%"
      color="white"
    >
      <Heading as="h1" zIndex="1" mb="sm" fontWeight="normal">
        {children}
      </Heading>
      <Text zIndex="1">
        <FormattedMessage id="frontpage.mainContent.paragraph1" />
      </Text>
      <Text zIndex="1">
        <FormattedMessage id="frontpage.mainContent.paragraph2" />
      </Text>
    </Flex>
  );
}

export function HeroBasic(): ReactElement {
  const {
    $store: {
      state: {
        partnerInfo: { partnerInfo },
        user,
      },
    },
  } = useContext(VueContext);

  return (
    <Flex flexDirection={{ base: "column", lg: "row" }}>
      <HeroImage>
        <Greeting firstName={user?.firstName} />
      </HeroImage>
      <Box
        mt={{ base: "xl", lg: "0" }}
        mr={{ xl: "4xl" }}
        minW={{ xl: "33.333%", "2xl": "30%" }}
        maxW={{ lg: "50%" }}
      >
        <Heading
          as="h3"
          fontSize={{ base: "xl", md: "3xl" }}
          fontWeight="normal"
          mt={{ lg: "4xl" }}
          mb={{ base: "lg", lg: "3xl" }}
        >
          {partnerInfo?.partnerName}
        </Heading>
        <Divider borderColor="brand.grayDark" />

        <Box mt="3xl">
          <ContactPersonBasic />
        </Box>
      </Box>
    </Flex>
  );
}
